<template>
  <div>
    <markdown-text-area
      :content="contentValue"
      :name="name"
      :attribute="attribute"
      :rows="rows"
      :placeholder="placeholder"
      :required="required"
      @update-preview="updateContent"
    />
    <markdown-preview :content="contentValue" />
  </div>
</template>

<script>
import MarkdownTextArea from '../components/markdown_text_area'
import MarkdownPreview from '../components/markdown_preview'

export default {
  name: 'MarkdownEditor',
  components: {
    MarkdownTextArea,
    MarkdownPreview
  },
  props: {
    content: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    attribute: {
      type: String,
      required: true
    },
    rows: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      contentValue: this.content
    }
  },
  methods: {
    updateContent (textInput) {
      this.contentValue = textInput
    }
  }
}
</script>
